export function asyncWrapper(func, arg1, arg2, ...otherArgs) {
  return new Promise((res, rej) => {
    setTimeout(() => {
      try {
        let funcRes = func(arg1, arg2, otherArgs);

        res(funcRes);
      } catch (err) {
        rej(err);
      }
    }, 5);
  });
}

export function asyncConfirm(msg) {
  return new Promise((res) => {
    let confirmRes = window.confirm(msg);

    res(confirmRes);
  });
}

export function getMatchesWithPositions(str, regExp) {
  let matches = str.match(regExp);
  let matchesWithPos = [];
  let pos = -1;

  if (matches === null) return matchesWithPos;

  matches.forEach((item) => {
    pos = str.indexOf(item, pos + 1);
    matchesWithPos.push({
      pos: pos,
      match: item,
    });
  });
  matchesWithPos.reverse();

  return matchesWithPos;
}

export function getObjectKey(obj, str) {
  return Object.keys(obj).find((key) => obj[key].toUpperCase() === str.trim().toUpperCase());
}

export function getMinorVersion(version) {
  let versionArr = version.split('.');

  return versionArr[1];
}
